import React, { Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import { useDispatch } from 'react-redux';

import { unlinkAll } from '../store/actions/devices';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: '2rem',
    paddingTop: '1rem',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 40,
  },
  button: {
    width: '40%',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  mainButton: {
    maxWidth: 200,
  },
}));

const StopMonitoringButton = ({ patient }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = () => {
    dispatch(unlinkAll(patient.id));
    setIsModalOpen(false);
  };

  return (
    <Fragment>
      <Button
        className={classes.mainButton}
        color="primary"
        size="small"
        variant="contained"
        onClick={() => setIsModalOpen(true)}
      >
        End Patient Trial
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
      >
        <Fade in={isModalOpen}>
          <div className={classes.paper}>
            <div>
              <h3 className={classes.title}>Are you sure you want to stop monitoring this patient?</h3>
              <p>Only take this action if the patient has finished the clinical trial.</p>
              <div className={classes.buttonRow}>
                <Button variant="contained" className={classes.button} onClick={() => setIsModalOpen(false)}>
                  No
                </Button>
                <Button variant="contained" className={classes.button} onClick={handleSubmit}>
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </Fragment>
  );
};

StopMonitoringButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.any.isRequired,
};

export default StopMonitoringButton;
